import { createReducer, createRequestReducer } from 'utils';
import {
  GET_PROFILE,
  DATA_CLEAR_PROFILE
} from '../../constants';

import {
  PUT_UPDATE_PROFILE,
  PUT_UPDATE_PASSWORD
} from '../../constants/profile';

const initialProfile = {};
const profile = createReducer(initialProfile, {
  [GET_PROFILE]: (state, action) => createRequestReducer(state, action, {
    SUCCESS: (state, action) => action.response,
    FAIL: () => initialProfile
  }),

  [PUT_UPDATE_PROFILE]: (state, action) => createRequestReducer(state, action, {
    SUCCESS: (state, action) => Object.assign({}, action.response,  { profileStatus: 'success' }),
    FAIL: () => initialProfile
  }),

  [DATA_CLEAR_PROFILE]: () => initialProfile,

  [PUT_UPDATE_PASSWORD]: (state, action) => createRequestReducer(state, action, {
    SUCCESS: (state) => Object.assign({}, state, { passwordStatus: 'success' })
  })
});

export default profile;



// WEBPACK FOOTER //
// ./src/reducers/profile/profile.js